import { ILocationModel, IContactModel, IFileModel } from './Common';
import { ICampaignModel } from "./Campaign";

export enum EnumPageLoadProcessSteps {
    INFO = 1,
    CONSUMERS = 2,
    PROCESS = 3
}

export enum EnumTypeConsumer {
    NORMAL = 1,
    WITHOUT_EMAIL = 2
}

export enum EnumConsumersLoadStatus {

    /**
     *  Dados carregamento validados / geração ficheiro carregamentos concluído com sucesso (BA)
     */
    Pending = 1,

    /**
     * Estado enviado a PSW com sucesso (BA/PSW)
     */
    Accepted = 2,

    /**
     * Estado não processo pela PSW, com erros (PSW/BA)
     */
    Rejected = 3,

    /**
     * Estado do processo com sucesso pela PSW (PSW/BA)
     */
    Finished = 4,

    /**
     * Criação dados gerais do carregamento (BA)
     */
    InProgress = 5,


    Canceled = 6,

    PendingApproval = 7,

    Idle = 8,

    // recusado por falta de comprovativos validos | processo interno | não comunica com a PSW
    Declined = 9,
    // nao sincronizado ocorre quando o comerciante nao esta criado na PSW | processo interno | não comunica com a PSW
    Not_Syncronized = 10,
}

export interface IConsumersLoadModel {
    Id: string;
    IdCommitment: string;
    CommitmentTotals?: {
        TotalCommitmentValueLabel: string,
        TotalChargingBalanceLabel: string,
        TotalUsedBalanceLabel: string,
        TotalRemainingBalanceLabel: string
    };
    Commitment: { Id?: string, Name?: string, InternalNumber?: string };
    IdAssignedVoucher?: string;
    Value?: string;
    Name: string;
    Observations: string;
    ChargingDate: string;
    StartDate: string;
    EndDate: string;
    CreateDate: string;
    ValueDefault: number;
    IdCampaign: string;
    IdCampaignStatus: number;
    Campaign?: ICampaignModel;
    Status: IConsumersLoadStatusModel;
    TotalValueCampaign: number;
    TotalConsumers: number;
    LastFile?: IConsumersLoadFileModel;
}

export class ConsumersLoadModel implements IConsumersLoadModel {
    Id: string;
    IdCommitment: string;
    CommitmentTotals?: {
        TotalCommitmentValueLabel: string,
        TotalChargingBalanceLabel: string,
        TotalUsedBalanceLabel: string,
        TotalRemainingBalanceLabel: string
    };
    Commitment: { Id?: string, Name?: string, InternalNumber?: string };
    IdAssignedVoucher?: string;
    Value?: string;
    Name: string;
    Observations: string;
    ChargingDate: string;
    StartDate: string;
    EndDate: string;
    CreateDate: string;
    ValueDefault: number;
    IdCampaign: string;
    IdCampaignStatus: number;
    Campaign?: ICampaignModel;
    Status: IConsumersLoadStatusModel;
    TotalValueCampaign: number;
    TotalConsumers: number;
    LastFile?: IConsumersLoadFileModel;

    constructor(data: Partial<IConsumersLoadModel> = {}) {

        this.Id = data?.Id || null;
        this.IdCommitment = data?.IdCommitment || null;
        this.IdAssignedVoucher = data?.IdAssignedVoucher || null;
        this.Value = data?.Value || null;
        this.Name = data?.Name || null;
        this.Observations = data?.Observations || null;
        this.ChargingDate = data?.ChargingDate || null;
        this.StartDate = data?.StartDate || null;
        this.EndDate = data?.EndDate || null;
        this.CreateDate = data?.CreateDate || null;
        this.ValueDefault = data?.ValueDefault || null;
        this.IdCampaign = data?.IdCampaign || null;
        this.IdCampaignStatus = data?.IdCampaignStatus || null;
        this.Campaign = data?.Campaign || null;
        this.Status = new ConsumersLoadStatusModel(data?.Status);
        this.TotalValueCampaign = data?.TotalValueCampaign || null;
        this.TotalConsumers = data?.TotalConsumers || null;
        this.CommitmentTotals = data?.CommitmentTotals || null;
        this.Commitment = data?.Commitment || null;
        this.LastFile = new ConsumersLoadFileModel(data?.LastFile);

    }
}

export interface IConsumersLoadFileModel {
    Id: string;
    OriginalName: string;
    Type: string;
    Path?: string;
    CreateDate?: string;
}

export class ConsumersLoadFileModel implements IConsumersLoadFileModel {
    Id: string;
    OriginalName: string;
    Type: string;
    Path?: string;
    CreateDate?: string;

    constructor(data: Partial<IConsumersLoadFileModel> = {}) {

        this.Id = data?.Id || null;
        this.OriginalName = data?.OriginalName || null;
        this.Type = data?.Type || null;
        this.Path = data?.Path || null;
        this.CreateDate = data?.CreateDate || null;
    }
}
export interface IConsumersLoadStatusModel {
    Id: number;
    IsSuccess: boolean;
    IsCompleted: boolean;
    Name: string;
    Color?: string;
    Icon?: string;
    Disabled?: boolean;
};

export class ConsumersLoadStatusModel {
    Id: number;
    IsSuccess: boolean;
    IsCompleted: boolean;
    Name: string;
    Color?: string;
    Icon?: string;
    Disabled?: boolean;

    constructor(data: Partial<IConsumersLoadStatusModel> = {}) {

        this.Id = data?.Id || null;
        this.IsSuccess = data?.IsSuccess || null;
        this.IsCompleted = data?.IsCompleted || null;
        this.Name = data?.Name || null;

        const statusThatDisableActions = [EnumConsumersLoadStatus.Finished, EnumConsumersLoadStatus.Accepted];

        this.Disabled = statusThatDisableActions.some(it => it == this.Id);

        // this.Icon = 'warning-outline';

        switch (Number(this.Id)) {
            case EnumConsumersLoadStatus.Finished:
                this.Color = 'success';
                this.Icon = 'checkmark-done-outline';
                break;
            case EnumConsumersLoadStatus.Accepted:
                this.Color = 'success';
                this.Icon = 'checkmark-outline';
                break;
            case EnumConsumersLoadStatus.InProgress:
                this.Color = 'secondary';
                this.Icon = 'hourglass-outline';
                break;
            case EnumConsumersLoadStatus.PendingApproval:
                this.Color = 'secondary';
                this.Icon = 'time-outline';
                break;
            case EnumConsumersLoadStatus.Canceled:
                this.Color = 'danger';
                this.Icon = 'alert-circle-outline';
                break;
            case EnumConsumersLoadStatus.Rejected:
                this.Color = 'danger';
                this.Icon = 'ban-outline';
                break;
            case EnumConsumersLoadStatus.Declined:
                this.Color = 'danger';
                this.Icon = 'pause-circle-outline';
                break;
            default:
                this.Color = 'warning';
                this.Icon = 'warning-outline';
                break;
        }

    }
}

export interface IConsumersResumeModel {
    Name: string;
    BirthDate?: string;
    RegistDate?: string;
    IdentificationDocumentNumber: string;
    VatNumber: string;
    BalanceLoading?: number;
    Observations: string;
    Email?: string;
    IdWallet?: string;
    WalletSynchronized?: boolean;
    IdUser?: string;
    CreateDate?: string;
    Index?: number;
    SynchronizedDate?: string;
    WalletCard?: {
        Id: string;
        Number: string;
        ValidationDate: string;
        Status: boolean
    };
    ModuleList?: any[];
    Image?: { Id: string, OriginalName?: string, Path: string, Type?: string, Base64Data?: string };

}

export class ConsumersResumeModel implements IConsumersResumeModel {
    Name: string;
    BirthDate?: string;
    RegistDate?: string;
    IdentificationDocumentNumber: string;
    VatNumber: string;
    BalanceLoading?: number;
    Observations: string;
    IdWallet?: string;
    Email?: string;
    WalletSynchronized?: boolean;
    IdUser?: string;
    CreateDate?: string;
    Index?: number;
    SynchronizedDate?: string;
    WalletCard?: {
        Id: string;
        Number: string;
        ValidationDate: string;
        Status: boolean
    };
    ModuleList?: any[];
    Image?: { Id: string, OriginalName?: string, Path: string, Type?: string, Base64Data?: string };

    constructor(data: Partial<IConsumersResumeModel> = {}) {

        this.Name = data?.Name || null;
        this.BirthDate = data?.BirthDate || null;
        this.RegistDate = data?.RegistDate || null;
        this.IdentificationDocumentNumber = data?.IdentificationDocumentNumber || null;
        this.VatNumber = data?.VatNumber || null;
        this.BalanceLoading = data?.BalanceLoading || null;
        this.Observations = data?.Observations || null;
        this.Email = data?.Email || null;
        this.IdWallet = data?.IdWallet || null;
        this.WalletSynchronized = data?.WalletSynchronized ?? false;
        this.IdUser = data?.IdUser ?? null;
        this.CreateDate = data?.CreateDate ?? null;
        this.Index = data?.Index || null;
        this.SynchronizedDate = data?.SynchronizedDate || null;
        this.WalletCard = data?.WalletCard || { Id: null, Number: null, ValidationDate: null, Status: null };
        this.ModuleList = data?.ModuleList || [];
        this.Image = data?.Image || null;
    }
}

export interface IConsumersWalletModel extends IConsumersResumeModel {

    /**required */
    IdSexGender?: number;
    Age?: number;
    IdentificationDocumentValidityDate?: string;
    IdentificationDocumentEmissionDate?: string;
    Image_Base64Data?: any;
    Username?: string;
    IdTemplate?: any;
    IsExternal?: boolean;
    EmailVerified?: boolean;
    IdDocumentType?: number;
    IdGender?: number;
    RowIndex?: number;

    /** not required */
    Password?: string;
    Location?: any;
    Contact?: any;
    EmergencyData?: any;
    WalletCard?: {
        Id: string,
        Number: string,
        Status: boolean,
        ValidationDate: string,
        PhysicalCardRequired?: boolean,
        IdWalletBalanceStatus300?: string
    };

    ModuleList?: { Id: string, Name: string }[];

    Image?: { Id: string, OriginalName?: string, Path: string, Type?: string, Base64Data?: string };

    ExternalUser_Id?: string;
    PhysicalCardRequired?: boolean;


    ModuleCampaignList?: {
        IdUser: string,
        ModuleList: IConsumersWalletCampaignListModuleModel[]
    };

    UserFilesList?: any[];
    IdWalletBalanceStatus300?: string;
}

export interface IConsumersWalletCampaignListModuleModel {
    IsUserAssociated: boolean,
    CampaignList: {
        CampaignStartDate?: string,
        IsUserAssociated: boolean,
        Type: { Id: string, Name?: string },
        Campaign: { Id: string, Name?: string },
        ImageList?: { Path: string, Type?: number, IsMain?: boolean }[]
    }[],
    Module: { Id: string, Name?: string }
}

export class ConsumersWalletModel extends ConsumersResumeModel implements IConsumersWalletModel {

    /**required */
    IdSexGender?: number;
    Age?: number;
    IdentificationDocumentValidityDate?: string;
    IdentificationDocumentEmissionDate?: string;
    Image_Base64Data?: any;
    Username?: string;
    IdTemplate?: any;
    IsExternal?: boolean;
    EmailVerified?: boolean;
    IdDocumentType?: any;
    RowIndex?: number;
    IdGender?: number;

    /** not required */
    Password?: string;
    Location?: any;
    Contact?: any;
    EmergencyData?: any;
    WalletCard?: {
        Id: string, Number: string, Status: boolean, ValidationDate: string, PhysicalCardRequired?: boolean
    };

    ModuleList?: { Id: string, Name: string }[];
    Image?: { Id: string, OriginalName?: string, Path: string, Type?: string };
    ExternalUser_Id?: string;
    PhysicalCardRequired?: boolean;

    ModuleCampaignList?: {
        IdUser: string,
        ModuleList: IConsumersWalletCampaignListModuleModel[]
    };

    UserFilesList?: any[];

    constructor(data: Partial<IConsumersWalletModel> = {}) {

        super(data);

        this.IdSexGender = data?.IdSexGender || null;
        this.Age = data?.Age || null;
        this.IdentificationDocumentValidityDate = data?.IdentificationDocumentValidityDate || null;
        this.IdentificationDocumentEmissionDate = data?.IdentificationDocumentEmissionDate || null;
        this.Image_Base64Data = data?.Image_Base64Data || null;
        this.Username = data?.Username || null;
        this.IdTemplate = data?.IdTemplate || null;
        this.IsExternal = data?.IsExternal || null;
        this.EmailVerified = data?.EmailVerified || null;
        this.IdDocumentType = data?.IdDocumentType || null;
        this.RowIndex = data?.RowIndex || null;
        this.IdGender = data?.IdGender || null;

        this.Password = data?.Password || null;
        this.Location = data?.Location || null;
        this.Contact = data?.Contact || null;
        this.EmergencyData = data?.EmergencyData || null;
        this.WalletCard = data?.WalletCard || null;
        this.ModuleList = data?.ModuleList || [];
        this.Image = data?.Image || null;
        this.ExternalUser_Id = data?.ExternalUser_Id || null;
        this.PhysicalCardRequired = data?.PhysicalCardRequired ?? null;
        this.ModuleCampaignList = data?.ModuleCampaignList || null;
        this.UserFilesList = data?.UserFilesList || [];

    }
}


export interface IConsumerIssueCardModel {
    IdWallet: string;
    StartDate: string;
    EndDate: string;
    Observations: string;
    IdNotificationSubmissionType: number;
}


/**
 * Payload da associação de um cartão ao agregado familiar do consumidor.
 */
export interface IHouseHoldCardAssociationModel {
    IdHouseHold?: string;
    IdUser?: string;
    IdUserList?: string[];
    IdMember?: string;
    IdMemberList?: string[];
    IdRequiredCard?: string;
    CardNumber?: string;
    IsMain?: boolean;
    IdRelationDegree?: number;
    IdStatus?: number;
    Observations?: string;
    AttachedFile?: IFileModel;
    IsNewHouseHold?: boolean;
    HouseHoldName?: string;
}


/**
 * Filtros da pesquisa de cartão. É obrigatório preencher um dos dois campos,
 * não é necessário preencher ambos.
 */
export interface IConsumerCardSearchFilterModel {
    VatNumber?: string;
    CardNumber?: string;
}


/**
 * Linha de resultado da pesquisa de cartão (por NIF / nº de cartão).
 */
export interface IConsumerCardSearchModel {
    Id?: string;
    IdUser?: string;
    IdWallet?: string;
    Name?: string;
    VatNumber?: string;
    CardNumber?: string;
}


export enum EnumWalletStatus {

    Pending = 1,
    Accepted = 2,
    Rejected = 3,
    NotConfigured = 202
}

/**
 * Estado da associação de um membro/cartão ao agregado familiar.
 */
export enum EnumHouseholdAssociationStatus {

    Pending = 1,
    Accepted = 2,
    Refused = 3,
    Cancelled = 6
}

export interface IConsumersWalletModuleModel {

    IdUser: string;
    IdWallet: string;
    IdWalletBalance: string;
    IdWalletBalanceStatus: string;
    Module: { Id: string, Name: string };
    Status: {
        Id: number, Name: string, Color?: string;
        Icon?: string;
    };
    Observations: string;
    RegistDate: string;
    Name: string;
    VatNumber: string;
    BirthDate: string;
    IdDocumentType: number;
    IdentificationDocumentNumber: string;
    IdentificationDocumentValidityDate: string;
    Location: ILocationModel;
    Contact: IContactModel;
    PhysicalCardRequired?: boolean;
    FileList?: any[],
    Image?: { Id: string, OriginalName?: string, Path: string, Type?: string },
    ObservationsPrivate?: string;

}

export class ConsumersWalletModuleModel implements IConsumersWalletModuleModel {
    IdUser: string;
    IdWallet: string;
    IdWalletBalance: string;
    IdWalletBalanceStatus: string;
    Module: { Id: string, Name: string };
    Status: {
        Id: number, Name: string, Color?: string;
        Icon?: string;
    };
    Observations: string;
    RegistDate: string;
    Name: string;
    VatNumber: string;
    BirthDate: string;
    IdDocumentType: number;
    IdentificationDocumentNumber: string;
    IdentificationDocumentValidityDate: string;
    Location: ILocationModel;
    Contact: IContactModel;
    PhysicalCardRequired?: boolean;
    FileList?: any[]
    Image?: { Id: string, OriginalName?: string, Path: string, Type?: string }
    ObservationsPrivate?: string;

    constructor(data: Partial<IConsumersWalletModuleModel> = {}) {

        this.IdUser = data?.IdUser || null;
        this.IdWallet = data?.IdWallet || null;
        this.IdWalletBalance = data?.IdWalletBalance || null;
        this.IdWalletBalanceStatus = data?.IdWalletBalanceStatus || null;
        this.Module = data?.Module || null;
        this.Status = new ConsumersLoadStatusModel(data?.Status);
        this.Observations = data?.Observations || null;
        this.RegistDate = data?.RegistDate || null;
        this.Name = data?.Name || null;
        this.VatNumber = data?.VatNumber || null;
        this.BirthDate = data?.BirthDate || null;
        this.IdDocumentType = data?.IdDocumentType || null;
        this.IdentificationDocumentNumber = data?.IdentificationDocumentNumber || null;
        this.IdentificationDocumentValidityDate = data?.IdentificationDocumentValidityDate || null;
        this.Location = data?.Location || null;
        this.Contact = data?.Contact || null;
        this.PhysicalCardRequired = data?.PhysicalCardRequired ?? null;
        this.FileList = data?.FileList || null;
        this.Image = data?.Image || null;
        this.ObservationsPrivate = data?.ObservationsPrivate || null;
    }
}


export interface IConsumersVoucherModel {
    Id: string;
    Value?: number;
    Name: string;
    CreateDate: string;
    Campaign?: ICampaignModel;
    User?: { Id: string, Name: string };
    CampaignChargingStatus: IConsumersLoadStatusModel;
    LastFile?: IConsumersLoadFileModel;
    VatNumber: string;
    WasUsed: boolean;
    IdModule: number;
}

export class ConsumersVoucherModel implements IConsumersVoucherModel {
    Id: string;
    Value?: number;
    Name: string;
    CreateDate: string;
    Campaign?: ICampaignModel;
    User?: { Id: string, Name: string };
    CampaignChargingStatus: IConsumersLoadStatusModel;
    LastFile?: IConsumersLoadFileModel;
    VatNumber: string;
    WasUsed: boolean;
    IdModule: number;

    constructor(data: Partial<IConsumersVoucherModel> = {}) {

        this.Id = data?.Id || null;
        this.Value = data?.Value || null;
        this.Name = data?.Name || null;
        this.CreateDate = data?.CreateDate || null;
        this.Campaign = data?.Campaign || null;
        this.User = data?.User || null;
        this.CampaignChargingStatus = new ConsumersLoadStatusModel(data?.CampaignChargingStatus);
        this.LastFile = new ConsumersLoadFileModel(data?.LastFile);
        this.VatNumber = data?.VatNumber || null;
        this.WasUsed = data?.WasUsed || null;
        this.IdModule = data?.IdModule || null;

    }
}